import React from 'react';
import { cx } from '../cx';

// D-09 — TextLink (인라인 텍스트 링크 스타일). 버튼(.btn)이 아니라 밑줄 링크 모양.
// 라우팅은 onClick 으로 처리(SPA). 접근성상 button 요소로 렌더한다.
// 신규 추가(표준문서 정비 대상).
export interface TextLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const TextLink = React.forwardRef<HTMLButtonElement, TextLinkProps>(function TextLink(
  { className = '', type, children, ...props },
  ref,
) {
  return (
    <button ref={ref} type={type ?? 'button'} className={cx('text-link', className)} {...props}>
      {children}
    </button>
  );
});
